<template>
  <c-footer :fixed="false">
    <c-row style="width: 100%">
      <c-col sm="12" md="11">
        <a href="https://koalaboss.com" target="_blank">
          <template v-if="$store.state.app.authenticatedUser.organisation.name.indexOf('Aspen') !== -1">
            KoalaBoss Enterprise Edition for {{ $store.state.app.authenticatedUser.organisation.name }}
<!--            KoalaBoss Enterprise Edition (v{{ $store.state.app.version }}) for {{ $store.state.app.authenticatedUser.organisation.name }}-->
          </template>
          <template v-else>
            KoalaBoss
          </template>
          </a>
        <span class="ml-1">&copy; {{ new Date().getFullYear() }}</span>
      </c-col>
      <c-col sm="12" md="1">
        <span class="text-muted float-md-right" @click="toggleDebug">v{{ $store.state.app.version }}</span>
      </c-col>
    </c-row>
    <debug-mode v-if="showDebugSplash" @close="showDebugSplash = false"/>
  </c-footer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DebugMode from '@/views/components/DebugMode.vue';

export default {
  name: 'TheFooter',
  components: { DebugMode },
  data() {
    return {
      debugClickCount: 0,
      showDebugSplash: false,
    };
  },
  computed: {
    ...mapGetters({
      debugMode: 'debugMode',
    }),
  },
  methods: {
    ...mapActions(['toggleDebugMode']),
    toggleDebug() {
      this.debugClickCount += 1;
      if (this.debugClickCount === 10) {
        this.toggleDebugMode(!this.debugMode);
        this.debugClickCount = 0;
        this.showDebugSplash = true;
      }
    },
  },
};
</script>
